/**
 * Browsing: which panel the sheet is showing.
 *
 * Only that. What each panel *contains* is a query now — the body asks for
 * the playlist or the term it is on and TanStack Query answers, so nothing
 * here fetches, caches, guards against a stale response or holds a loading
 * flag. See `queries.ts`.
 *
 * Every entry point is a toggle — pressing Library while the library is open
 * closes it — which is what makes the side rail and its shortcuts feel like
 * one control rather than two.
 */

import { demoTracks } from '../data/demo-library.ts';
import * as ui from '../state/ui.ts';
import type { Playlist, Track } from '../types/media.ts';

export function showLibrary(): void {
  if (ui.sheetShowing('home')) ui.closeSheet();
  else ui.openSheet('home', 'Library');
}

export function openPlaylist(p: Playlist): void {
  ui.openSheet('playlist', p.title, p);
}

export function showSearch(): void {
  if (ui.sheetShowing('search')) ui.closeSheet();
  else ui.openSheet('search', 'Search');
}

export function showQueue(): void {
  if (ui.sheetShowing('queue')) ui.closeSheet();
  else ui.openSheet('queue', 'Queue');
}

/** The crate the app starts with, cued up but silent. */
export const startingCrate = (): readonly Track[] => demoTracks;
